<template>
    <b-card no-body>
        <v-table    ref="table"
                    :fields="fields"
                    :buttons="buttons"
                    :items-provider="provider"
                    :initial-load="false">
                <template #additional-actions>
                        <div class="row align-items-center">
                            <div class="col-md-1 mb-1 mb-md-0">
                                <select class="form-control bg-img-none" v-model="donem.month">
                                    <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-1 mb-1 mb-md-0">
                                <select class="form-control bg-img-none" v-model="donem.year">
                                    <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                </select>
                            </div>
                            <div class="col-md-5 mb-1 mb-md-0">
                                <v-select-list :options="employeeSalaryGroups" label="Value" v-model="employeeSalaryGroupId" placeholder="Tüm Maaş Grupları"></v-select-list>
                            </div>
                            <div class="col-md-auto">
                                <button class="btn btn-success" v-on:click="$refs.table.refresh()">Sorgula</button>
                            </div>
                        </div>
                </template>
                </v-table>
    </b-card>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import moment from 'moment'
import { BCard } from 'bootstrap-vue'

export default{
    components:{
        BCard
    },
    data(){
        return {
            fields:[
                {thClass:'w-40',name:'Maaş Grubu',key:'EmployeeSalaryGroupName'},
                {thClass:'w-40',name:'Maaş Sayısı',key:'TotalCount'},
                {thClass:'w-20',name:'Kilitli',key:'Locked'}
            ],
            buttons:[
                {text:"Kilitle",key:"lock",icon:"LockIcon",variant:"danger",action:this.lock, condition:(item) => item.Locked == false},
                {text:"Kilidi kaldır",key:"lock",icon:"UnlockIcon",variant:"success",action:this.unlock, condition:(item) => item.Locked == true},
            ],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            years:[],
            donem:{
                year:moment().year(),
                month:moment().month() + 1 
            },
            employeeSalaryGroups:[],
            employeeSalaryGroupId:null
        }
    },
    mounted(){
        this.configureYears(),
        this.getEmployeeSalaryGroups()
    },
    methods:{
        provider(){
            return EmployeeOperationsApi.RSalaryLockedListByBranch({
                Month: this.donem.month,
                Year: this.donem.year,
                EmployeeSalaryGroupId:this.employeeSalaryGroupId?.Key||null,
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 2015
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        getEmployeeSalaryGroups(){
            EmployeeOperationsApi.SalaryGroup.List().then(res=>{
                this.employeeSalaryGroups = res.data
            })
        },
        lock(item){
            console.log(item)
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.LucaResult.Lock({
                Lock:true,
                EmployeeSalaryGroupId:item?.EmployeeSalaryGroupId || null,
                Month: this.donem.month,
                Year: this.donem.year,
            }).then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
                this.$result(res)
                this.$refs.table.rowLoading(false)
            }).catch(err => {
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        },
        unlock(item){
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.LucaResult.Lock({
                Lock:false,
                EmployeeSalaryGroupId:item?.EmployeeSalaryGroupId || null,
                Month: this.donem.month,
                Year: this.donem.year,
            }).then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
                this.$result(res)
                this.$refs.table.rowLoading(false)
            }).catch(err => {
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        }
    }
}
</script>